<template>
    <div>
        <div class="user_avatar ml-auto mr-auto">
            <v-avatar size="161" v-bind="avatar" style="cursor: pointer">
                <img v-if="url && !status.loading" :src="url" />

                <slot v-if="!url && !status.loading" name="none">
                    <v-icon large></v-icon>
                </slot>

                <slot v-if="status.loading" name="loading" :status="status">
                    <v-progress-circular
                        :value="status.progress"
                        :size="32"
                        :width="2"
                        color="primary"
                    />
                </slot>
            </v-avatar>

            <input
                type="file"
                ref="file"
                name="file"
                @change="select($event.target.name, $event.target.files)"
                style="display: none"
            />

            <div class="avatar_overlay">
                <img src="../assets/edit.svg" alt="edit" @click="click" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        url: {
            type: String,
            required: true
        },
        request: {
            type: Function,
            required: true
        },
        rename: {
            type: Function,
            required: false,
            default: file => file.name
        },
        avatar: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },
    data: () => ({
        field: "file",
        status: {
            loading: false,
            progress: 0
        }
    }),
    methods: {
        click() {
            if (!this.status.loading) {
                if (!this.url) {
                    this.choose();
                } else {
                    this.replace();
                }
            } else {
                this.$emit("cancel");
            }
        },
        choose() {
            return this.$refs.file.click();
        },
        replace() {
            if (this.$listeners.replace) {
                this.$emit("replace");
            } else {
                this.choose();
            }
        },
        select(field, file) {
            this.field = field;
            const [image] = file;
            if (file.length > 0) {
                if (!image.type.match("image.*")) {
                    this.$emit("error-type");
                } else {
                    this.upload(image);
                }
            } else {
                this.$emit("error-empty");
            }
        },
        async upload(file) {
            this.status.loading = true;
            const form = new FormData();
            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    ...this.headers
                },
                onUploadProgress: function(event) {
                    if (event.lengthComputable) {
                        const progress = (event.loaded / event.total) * 100;
                        this.status.progress = progress;
                        this.$emit("progress", progress);
                    }
                }.bind(this)
            };
            form.append(this.field, file, this.rename(file));
            try {
                const upload = await this.request(form, config);
                this.$emit("success", upload);
            } catch (e) {
                this.$emit("failed", e);
            } finally {
                this.status.loading = false;
                this.status.progress = 0;
            }
        }
    }
};
</script>

<style scoped>
.user_avatar {
    width: 161px;
    height: 161px;
    position: relative;
    cursor: pointer;
}
.user_avatar > img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.avatar_overlay {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: linear-gradient(
        0deg,
        rgba(44, 67, 112, 0.65),
        rgba(44, 67, 112, 0.65)
    );
}
.avatar_overlay img {
    width: 43px;
    height: 43px;
}
</style>
